import styled from '@emotion/styled';
import MenuIcon from '@mui/icons-material/Menu';
import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { memo, useCallback, useContext, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Link } from 'react-router-dom';
import Logo from '../../assets/logo.png';
import { AuthContext } from '../../contexts/AuthContext';

export const NavbarRoot = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.neutral[200],
  boxShadow: theme.shadows[3],
}));

const menuItems = [
  {
    name: 'Fanpage',
    href: 'https://www.fb.com/websiteyumyum',
  },
  {
    name: 'Google analytics',
    href: 'https://analytics.google.com/analytics/web/#/p318312798/reports/intelligenthome',
  },
  {
    name: 'Giao hàng nhanh',
    href: 'https://5sao.ghn.dev/',
  },
  {
    name: 'Stripe',
    href: 'https://dashboard.stripe.com/test/payments',
  },
  {
    name: 'Momo',
    href: 'https://test-business.momo.vn/transactionHistory',
  },
  {
    name: 'Heroku',
    href: 'https://dashboard.heroku.com/apps/yum-yum-backend',
  },
  {
    name: 'Netlify',
    href: 'https://app.netlify.com/sites/yum-yum-19dthd4/overview',
  },
  {
    name: 'Chat plugin',
    href: 'https://business.facebook.com/latest/inbox/settings/chat_plugin?asset_id=113821921334908',
  },
  {
    name: 'Cloudinary',
    href: 'https://cloudinary.com/console/c-0346066b1b3d3c4720b3d16f7c62d8',
  },
  {
    name: 'Google console',
    href: 'https://console.cloud.google.com/apis/credentials?project=yum-yum-352305',
  },
  {
    name: 'Sendgrid',
    href: 'https://app.sendgrid.com/',
  },
  {
    name: 'Visitor counter',
    href: 'https://apps.elfsight.com/panel/applications/visitor-counter/',
  },
];

export const Navbar = memo((props) => {
  const { onSidebarOpen, ...other } = props;
  const [anchorElUser, setAnchorElUser] = useState(null);
  const {
    authState: {
      user: { username, avatar },
    },
    logoutUser,
  } = useContext(AuthContext);

  const logout = useCallback(() => {
    logoutUser();
  }, [logoutUser]);

  const handleOpenUserMenu = useCallback((event) => {
    setAnchorElUser(event.currentTarget);
  }, []);

  const handleCloseUserMenu = useCallback(() => {
    setAnchorElUser(null);
  }, []);

  return (
    <NavbarRoot
      sx={{
        left: {
          lg: 250,
        },
        width: {
          lg: 'calc(100% - 250px)',
        },
      }}
      {...other}
    >
      <Toolbar
        disableGutters
        sx={{
          minHeight: 64,
          left: 0,
          px: 2,
        }}
      >
        <IconButton
          onClick={onSidebarOpen}
          sx={{
            display: {
              xs: 'inline-flex',
              lg: 'none',
            },
          }}
        >
          <MenuIcon fontSize="small" />
        </IconButton>
        <Link to="/">
          {/* <img alt="HUTECH" src={Logo} width="150px" /> */}
          <LazyLoadImage
            effect="blur"
            src={Logo}
            alt="logo"
            width="150px"
            placeholderSrc="img/logo.png"
          />
        </Link>
        <Box sx={{ flexGrow: 1 }} />
        <Box>
          <Tooltip title="Mở cài đặt">
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
              <Avatar
                alt={username}
                src={
                  avatar?.imageUrl
                    ? avatar?.imageUrl
                    : 'https://images.unsplash.com/photo-1579353977828-2a4eab540b9a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1974&q=80'
                }
              />
            </IconButton>
          </Tooltip>
          <Menu
            sx={{ mt: '45px' }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
          >
            <Link to="/personal-info">
              <MenuItem>
                <Typography textAlign="center" color="#121828">
                  Thông tin cá nhân
                </Typography>
              </MenuItem>
            </Link>
            {menuItems.map((menuItem) => (
              <a href={menuItem.href} target="blank" key={menuItem.name}>
                <MenuItem>
                  <Typography textAlign="center" color="#121828">
                    {menuItem.name}
                  </Typography>
                </MenuItem>
              </a>
            ))}
            <MenuItem onClick={logout}>
              <Typography textAlign="center">Đăng xuất</Typography>
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </NavbarRoot>
  );
});

Navbar.propTypes = {
  onSidebarOpen: PropTypes.func,
};
